import { PageMeta } from '../components/PageMeta'

const publicEmail =
  (import.meta.env.VITE_PUBLIC_CONTACT_EMAIL as string | undefined) || 'hello@informat.ie'

export function PrivacyPage() {
  return (
    <main id="main-content" className="route-page privacy-page-v2 section-light">
      <PageMeta
        title="Privacy notice"
        description="How Informat Limited handles personal information submitted through this website."
      />
      <header className="privacy-hero">
        <h1>Privacy notice</h1>
        <p>
          This notice explains how Informat Limited handles personal information submitted through
          this website.
        </p>
        <span>Last updated 30 July 2026</span>
      </header>
      <div className="privacy-layout">
        <aside>
          <nav aria-label="Privacy notice sections">
            <a href="#controller">Who is responsible</a>
            <a href="#information">Information collected</a>
            <a href="#use">How it is used</a>
            <a href="#providers">Service providers</a>
            <a href="#retention">Retention</a>
            <a href="#rights">Your rights</a>
            <a href="#cookies">Cookies and analytics</a>
          </nav>
        </aside>
        <div className="privacy-sections">
          <section id="controller">
            <h2>Who is responsible</h2>
            <p>
              Informat Limited is the controller of personal information submitted through this
              website. Informat is an Irish limited company based in Gorey, County Wexford, Ireland.
            </p>
            <p>
              Privacy questions can be sent through the <a href="/contact">contact page</a>
              {publicEmail && (
                <>
                  {' '}
                  or by email to <a href={`mailto:${publicEmail}`}>{publicEmail}</a>
                </>
              )}
              .
            </p>
          </section>
          <section id="information">
            <h2>Information collected</h2>
            <p>
              If you send an enquiry, Informat receives the first and last name, work email,
              business name, optional telephone number, area of interest, project description,
              timing and response preference you provide. The hosting and form services may also
              process technical request information such as IP address and browser information.
            </p>
            <p>
              Please do not submit passwords, access tokens, payment details, customer records,
              health information or other sensitive information through the enquiry form.
            </p>
          </section>
          <section id="use">
            <h2>How the information is used</h2>
            <p>
              Enquiry information is used to assess and respond to your request, discuss possible
              work, maintain appropriate business correspondence, protect the website and comply
              with applicable obligations.
            </p>
            <p>
              Depending on the circumstances, the relevant basis is taking steps at your request
              before entering a contract, performing a contract, complying with a legal obligation,
              or Informat’s legitimate interest in responding to genuine business enquiries and
              maintaining appropriate business records.
            </p>
            <p>The website enquiry form does not add you to a marketing list.</p>
          </section>
          <section id="providers">
            <h2>Service providers and transfers</h2>
            <p>
              The website is hosted on Cloudflare Pages. Fillout, operated by Zite, is used to
              display the enquiry form, store submissions and send submission notifications. These
              providers process technical information and enquiry content on Informat’s behalf
              under their applicable terms.
            </p>
            <p>
              Providers may process information outside Ireland or the European Economic Area.
              Informat will rely on the provider’s applicable contractual and transfer safeguards
              where required.
            </p>
          </section>
          <section id="retention">
            <h2>How long information is kept</h2>
            <p>
              Enquiries are kept only for as long as reasonably necessary to respond, manage any
              resulting business relationship, maintain appropriate records, resolve disputes and
              meet legal, tax, insurance or contractual obligations. Unsuccessful or irrelevant
              enquiries are removed when they are no longer needed.
            </p>
          </section>
          <section id="rights">
            <h2>Your data-protection rights</h2>
            <p>
              Subject to the circumstances and applicable law, you may have rights to request
              access, correction, erasure, restriction, portability or to object to processing. You
              may also raise a concern with Ireland’s Data Protection Commission.
            </p>
            <p>
              Start by contacting Informat using the details above. More information is available
              from the{' '}
              <a href="https://www.dataprotection.ie/" rel="noreferrer" target="_blank">
                Data Protection Commission
              </a>
              .
            </p>
          </section>
          <section id="cookies">
            <h2>Cookies and analytics</h2>
            <p>
              This version of the website does not add advertising cookies or marketing analytics.
              Cloudflare and Turnstile may use strictly necessary technical storage or security
              signals to deliver and protect the website.
            </p>
          </section>
          <section>
            <h2>Changes to this notice</h2>
            <p>
              This notice may be updated when the website, providers or processing activities
              change. The current revision date will remain visible at the top of the page.
            </p>
          </section>
        </div>
      </div>
    </main>
  )
}
